import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { RadioItemProps } from 'src/components/primitives/RadioGroup/types';
import { getRadioItemCardClassName } from 'src/components/primitives/RadioGroup/utils';

export default function RadioItemCard<T extends string>({
	id,
	value,
	className,
	disabled,
	size,
	label,
	dataTestId,
	...rest
}: RadioItemProps<T>) {
	return (
		<RadixRadioGroup.Item
			id={id}
			value={value}
			disabled={disabled}
			className={getRadioItemCardClassName({ size, disabled, className })}
			data-testid={dataTestId}
			{...rest}
		>
			{label}
		</RadixRadioGroup.Item>
	);
}
